/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PetCalendarEventModel
 */
export interface PetCalendarEventModel {
    /**
     * 
     * @type {string}
     * @memberof PetCalendarEventModel
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof PetCalendarEventModel
     */
    eventTypeId: number;
    /**
     * 
     * @type {string}
     * @memberof PetCalendarEventModel
     */
    eventType: PetCalendarEventModelEventTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof PetCalendarEventModel
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof PetCalendarEventModel
     */
    endDate: Date;
}


/**
 * @export
 */
export const PetCalendarEventModelEventTypeEnum = {
    Unknown: 'UNKNOWN',
    BirthdayAnniversary: 'BIRTHDAY_ANNIVERSARY',
    AdoptionAnniversary: 'ADOPTION_ANNIVERSARY'
} as const;
export type PetCalendarEventModelEventTypeEnum = typeof PetCalendarEventModelEventTypeEnum[keyof typeof PetCalendarEventModelEventTypeEnum];


/**
 * Check if a given object implements the PetCalendarEventModel interface.
 */
export function instanceOfPetCalendarEventModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "eventTypeId" in value;
    isInstance = isInstance && "eventType" in value;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "endDate" in value;

    return isInstance;
}

export function PetCalendarEventModelFromJSON(json: any): PetCalendarEventModel {
    return PetCalendarEventModelFromJSONTyped(json, false);
}

export function PetCalendarEventModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetCalendarEventModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'eventTypeId': json['eventTypeId'],
        'eventType': json['eventType'],
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
    };
}

export function PetCalendarEventModelToJSON(value?: PetCalendarEventModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'eventTypeId': value.eventTypeId,
        'eventType': value.eventType,
        'startDate': (value.startDate.toISOString()),
        'endDate': (value.endDate.toISOString()),
    };
}

